import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-multi-icon-renderer",
  template: `
    <div class="multi-icons">
      <div *ngFor="let linkObj of iconObjList" class="icon">
        <span *ngIf="linkObj.show" [ngClass]="linkObj.className">
          <span class="icon-link" *ngIf="linkObj.hasCallBack">
            <va-icon
              name="linkObj.icon"
              class="link-icon"
              nz-tooltip
              nzTooltipTitle="{{ linkObj.title }}"
              (click)="linkObj.clickCallback(linkObj.clickData)"
            ></va-icon>
          </span>
          <span class="icon-link" *ngIf="!linkObj.hasCallBack">
            <va-icon
              name="linkObj.icon"
              class="link-icon"
              nz-tooltip
              nzTooltipTitle="{{ linkObj.title }}"
            ></va-icon>
          </span>
          <span class="icon-text" *ngIf="linkObj.hasText">
            <span (click)="linkObj.clickCallback(linkObj.clickData)">
              {{ linkObj.linkText }}
            </span>
          </span>
        </span>
      </div>
    </div>
  `,
  styles: [
    `
      .multi-icons {
        display: flex;
      }
      .icon {
        margin-right: 8px;
      }
      .icon-link {
        cursor: pointer;
        color: #1874ae;
        font-size: 14px;
      }
      .icon-text {
        cursor: pointer;
        color: #1874ae;
        font-size: 12px;
      }
    `,
  ],
})
export class MultiIconRendererComponent implements OnInit {
  @Input() iconObjList: Array<any> = [];

  ngOnInit() {
    this.iconObjList.forEach((element) => {
      element.hasCallBack = element.clickCallback !== null;
      element.hasText = element.linkText !== undefined;
    });
  }
}
